// AdvanceSettingsForm.jsx
import React, { useEffect, useMemo } from "react";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setFormData } from "../../../../../features/OrgAdmin/orgAdminSlice";
import FormSection from "./CardSection";
import { getSections } from "./CardDetails";

function AdvanceSettingsForm() {
  const dispatch = useDispatch();
  const { selectedOrg, formData } = useSelector((state) => state.org);

  const mapConfigToForm = (config, orgInfo, source) => ({
    journeyStatus: orgInfo?.disableJourneys ? "disabled" : "enabled",
    speedLimit: orgInfo?.speedLimit ? orgInfo.speedLimit * 3.6 : 0,
    licenseCount: orgInfo?.licenseCount ?? source?.licenseCount ?? 0,
    smsFeature:
      config?.push_option === "PUSH_ONLY" ? "pushOnly" :
        config?.push_option === "OPTIMIZED" ? "optimized" :
          config?.push_option === "SMS" ? "sms" : "disabled",
    dhundhooLink: config?.sms_option === "SMS_NO_LINK" ? "dontSend" : "send",
    attendance: config?.attendance_option === "ENABLED" ? "enable" : "disable",
    odometer: config?.odometer === "ENABLED" ? "enable" : "disable",
    logs: config?.logs_option === "ENABLED" ? "enable" : "disable",
    management: config?.management === "ENABLED" ? "enable" : "disable",
    routeOptimization: config?.routeOptimization === "ENABLED" ? "enable" : "disable",
    alerts: config?.alert === "ENABLED" ? "enable" : "disable",
    planning: config?.planning === "ENABLED" ? "enable" : "disable",
    tripDetails: config?.trip === "ENABLED" ? "enable" : "disable",
    paymentWallet: config?.wallet === "ENABLED" ? "enable" : "disable",
    jobRole: config?.jobRole === "ENABLED" ? "enable" : "disable",
    fuelLog: config?.fuelLog === "ENABLED" ? "enable" : "disable",
    liveCamera: config?.liveCamera === "ENABLED" ? "enable" : "disable",
    orgType:
      config?.orgType === "SCHOOL" ? "School" :
        config?.orgType === "CORPORATE" ? "Corporate" :
          config?.orgType === "TRANSPORT" ? "Transport" :
            config?.orgType === "OTHER" ? "Other" : "",
    vendorConfigurations:
      config?.vendor_option === "VENDOR_ONLY" ? "vendorOnly" :
        config?.vendor_option === "DHUNDHOO_VENDOR" ? "dhundhooVendor" :
          config?.vendor_option === "ENABLE_VENDOR_PLUS" ? "vendorPlus" : "noVendor",
    webApiKey: orgInfo?.apiKey || "",
    vendorHandle: orgInfo?.vendorHandle || "",
  });

  // Load config when selectedOrg changes
  useEffect(() => {
    if (selectedOrg?.orgInfo?.config) {
      const config = selectedOrg.orgInfo.config;
      const orgInfo = selectedOrg.orgInfo;
      const source = selectedOrg._source;
      dispatch(setFormData(mapConfigToForm(config, orgInfo, source)));
    }
  }, [selectedOrg, dispatch]);

  const sections = useMemo(
    () => getSections(formData, selectedOrg ? [selectedOrg] : [], dispatch),
    [formData, selectedOrg, dispatch]
  );

  return (
    <Box sx={{ mx: "auto", p: 3 }}>
      <Grid container spacing={3}>
        {sections.map((section) =>
          section.custom ? (
            section.render
          ) : (
            <FormSection
              key={section.name}
              title={section.title}
              name={section.name}
              value={section.value}
              options={section.options || []}
            />
          )
        )}
        <Grid item xs={12}>
          <Divider sx={{ my: 2 }} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default AdvanceSettingsForm;